// import React from 'react'
// import expire from '../../core/img/expire.png'
// import { useSelector } from 'react-redux';
// import {AlertTriangle } from "feather-icons-react/build/IconComponents";

// const ValidityComponent = () => {
//     const {isBetweenAMCPeriod,isTodayOrAfterAMCToDate,remainingDaysToExtension} = useSelector((state) => state.amc);
//   return (
//     <div>
//         {isBetweenAMCPeriod && isTodayOrAfterAMCToDate &&
//     <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' ,paddingTop:"70px" , color:'#ff9f43',fontWeight:'bold', marginBottom:"-70px"}}>
//       <AlertTriangle size={18}/> &nbsp; Your software subscription is about to EXPIRE in just {remainingDaysToExtension} days, Renew today !
//   </div>
//         }
//     </div>
//   )
// }

// export default ValidityComponent

import React, { useEffect, useState } from 'react';
import expire from '../../core/img/expire.png';
import { useSelector } from 'react-redux';
import { AlertTriangle } from "feather-icons-react/build/IconComponents";
import axios from 'axios';

const ValidityComponent = () => {
  const {
    isBetweenAMCPeriod,
    isTodayOrAfterAMCToDate,
    remainingDaysToExtension
  } = useSelector((state) => state.amc);

  const [isRequesting, setIsRequesting] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);

  // ⏱ Countdown effect
  useEffect(() => {
    let timer;
    if (isRequesting && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft(prev => prev - 1);
      }, 1000);
    }

    if (timeLeft === 0 && isRequesting) {
      setIsRequesting(false);
    }

    return () => clearInterval(timer);
  }, [isRequesting, timeLeft]);

  // 📡 API Call
  const handleRenewRequest = async () => {
    try {
      setIsRequesting(true);
      setTimeLeft(600); // 10 min

      await axios.post('/api/amc/activate'); // 🔁 connect your backend
    } catch (err) {
      console.error(err);
      setIsRequesting(false);
    }
  };

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s < 10 ? '0' : ''}${s}`;
  };

  if (!(isBetweenAMCPeriod && isTodayOrAfterAMCToDate)) return null;

  return (
    <div style={{ textAlign: 'center', paddingTop: '60px' }}>
      
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#ff9f43',
        fontWeight: 'bold',
        marginBottom: '15px'
      }}>
        <AlertTriangle size={18} />
        &nbsp; Your subscription will expire in {remainingDaysToExtension} days
      </div>

      {/* 🔘 Button */}
      {!isRequesting && (
        <button
          onClick={handleRenewRequest}
          style={{
            background: '#ff9f43',
            border: 'none',
            padding: '10px 20px',
            color: '#fff',
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          Request Renewal
        </button>
      )}

      {/* ⏳ Timer */}
      {isRequesting && (
        <div style={{ marginTop: '15px', color: '#ff4d4f', fontWeight: 'bold' }}>
          Renewal request sent! Time left: {formatTime(timeLeft)}
        </div>
      )}
    </div>
  );
};

export default ValidityComponent;